/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：862
 */

var r = require(/* 1433 */"../../../../../../253/2568/2569/2570/865/1433/index")
var i = require(/* 2475 */"./2475/index")
var o = require(/* 771 */"../../../2477/2536/771/index")
module.exports = function (e) {
  return o(e) ? r(e) : i(e)
}
